import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// App-chrome strings only. Report labels come from report definitions; extensions
// bring their own strings.
const resources = {
    de: {
        translation: {
            'app.loading': 'Wird geladen…',
            'app.notFound': 'Seite nicht gefunden',
            'app.signInRequired': 'Bitte melden Sie sich an',
            'extension.unavailable': 'Diese Ansicht ist vorübergehend nicht verfügbar',
            'extension.notLoaded': 'Die kundenspezifischen Ansichten sind vorübergehend nicht verfügbar',
            'app.tenantUnknown': 'Der Arbeitsbereich konnte nicht ermittelt werden',
            'app.userMenu': 'Benutzermenü',
            'app.navMenu': 'Menü',
            'app.signOut': 'Abmelden',
            'app.demo': 'DEMO',
            'erp.menu': 'ERP',
            'erp.settings': 'Einstellungen',
            'app.demoHint': 'Beispieldaten – keine echten Zahlen',
            'app.language': 'Sprache',
            'app.version': 'Version {{version}}',
            'app.updateAvailable': 'Eine neue Version ist verfügbar.',
            'app.reload': 'Neu laden',
            'app.unreachable': 'Der Server ist gerade nicht erreichbar. Sie bleiben angemeldet.',
            'app.retry': 'Erneut versuchen',
            'login.title': 'Anmelden',
            'login.email': 'E-Mail',
            'login.password': 'Passwort',
            'login.remember': 'Angemeldet bleiben',
            'login.submit': 'Anmelden',
            'login.signingIn': 'Anmeldung läuft…',
            'login.failed': 'Anmeldung fehlgeschlagen. Bitte E-Mail und Passwort prüfen.',
            'login.sso.microsoft': 'Weiter mit Microsoft',
            'login.sso.google': 'Weiter mit Google',
            'login.sso.demo': 'In der Demo nicht verfügbar',
            'login.or': 'oder',
            'login.welcome': 'Willkommen zurück.',
        },
    },
    et: {
        translation: {
            'app.loading': 'Laadin…',
            'app.notFound': 'Lehte ei leitud',
            'app.signInRequired': 'Jätkamiseks logi sisse',
            'extension.unavailable': 'See vaade pole hetkel saadaval',
            'extension.notLoaded': 'Kohandatud vaated pole hetkel saadaval',
            'app.tenantUnknown': 'Tööruumi ei õnnestunud tuvastada',
            'app.userMenu': 'Kasutaja menüü',
            'app.navMenu': 'Menüü',
            'app.signOut': 'Logi välja',
            'app.demo': 'DEMO',
            'erp.menu': 'ERP',
            'erp.settings': 'Seaded',
            'app.demoHint': 'Näidisandmed – mitte päris numbrid',
            'app.language': 'Keel',
            'app.version': 'Versioon {{version}}',
            'app.updateAvailable': 'Uus versioon on saadaval.',
            'app.reload': 'Laadi uuesti',
            'app.unreachable': 'Server ei ole hetkel kättesaadav. Te jääte sisselogituks.',
            'app.retry': 'Proovi uuesti',
            'login.title': 'Logi sisse',
            'login.email': 'E-post',
            'login.password': 'Parool',
            'login.remember': 'Jäta mind meelde',
            'login.submit': 'Logi sisse',
            'login.signingIn': 'Login sisse…',
            'login.failed': 'Sisselogimine ebaõnnestus. Kontrolli e-posti ja parooli.',
            'login.sso.microsoft': 'Jätka Microsofti kontoga',
            'login.sso.google': "Jätka Google'i kontoga",
            'login.sso.demo': 'Demos pole saadaval',
            'login.or': 'või',
            'login.welcome': 'Tere tulemast tagasi.',
        },
    },
    en: {
        translation: {
            'app.loading': 'Loading…',
            'app.notFound': 'Page not found',
            'app.signInRequired': 'Sign in to continue',
            'extension.unavailable': 'This view is temporarily unavailable',
            'extension.notLoaded': 'Custom views are temporarily unavailable',
            'app.tenantUnknown': 'Could not identify the workspace',
            'app.userMenu': 'User menu',
            'app.navMenu': 'Menu',
            'app.signOut': 'Sign out',
            'app.demo': 'DEMO',
            'erp.menu': 'ERP',
            'erp.settings': 'Settings',
            'app.demoHint': 'Sample data – not real figures',
            'app.language': 'Language',
            'app.version': 'Version {{version}}',
            'app.updateAvailable': 'A new version is available.',
            'app.reload': 'Reload',
            'app.unreachable': 'The server can’t be reached right now. You are still signed in.',
            'app.retry': 'Try again',
            'login.title': 'Sign in',
            'login.email': 'Email',
            'login.password': 'Password',
            'login.remember': 'Remember me',
            'login.submit': 'Sign in',
            'login.signingIn': 'Signing in…',
            'login.failed': 'Sign-in failed. Check your email and password.',
            'login.sso.microsoft': 'Continue with Microsoft',
            'login.sso.google': 'Continue with Google',
            'login.sso.demo': 'Not available in the demo',
            'login.or': 'or',
            'login.welcome': 'Welcome back.',
        },
    },
    ru: {
        translation: {
            'app.loading': 'Загрузка…',
            'app.notFound': 'Страница не найдена',
            'app.signInRequired': 'Войдите, чтобы продолжить',
            'extension.unavailable': 'Этот раздел временно недоступен',
            'extension.notLoaded': 'Разделы клиента временно недоступны',
            'app.tenantUnknown': 'Не удалось определить рабочее пространство',
            'app.userMenu': 'Меню пользователя',
            'app.navMenu': 'Меню',
            'app.signOut': 'Выйти',
            'app.demo': 'DEMO',
            'erp.menu': 'ERP',
            'erp.settings': 'Настройки',
            'app.demoHint': 'Демонстрационные данные – не реальные цифры',
            'app.language': 'Язык',
            'app.version': 'Версия {{version}}',
            'app.updateAvailable': 'Доступна новая версия.',
            'app.reload': 'Обновить',
            'app.unreachable': 'Сервер сейчас недоступен. Вы по-прежнему в системе.',
            'app.retry': 'Повторить',
            'login.title': 'Вход',
            'login.email': 'Эл. почта',
            'login.password': 'Пароль',
            'login.remember': 'Запомнить меня',
            'login.submit': 'Войти',
            'login.signingIn': 'Вход…',
            'login.failed': 'Не удалось войти. Проверьте эл. почту и пароль.',
            'login.sso.microsoft': 'Продолжить с Microsoft',
            'login.sso.google': 'Продолжить с Google',
            'login.sso.demo': 'Недоступно в демо',
            'login.or': 'или',
            'login.welcome': 'С возвращением.',
        },
    },
}

void i18n.use(initReactI18next).init({
    resources,
    lng: 'et',
    fallbackLng: 'en',
    interpolation: { escapeValue: false }, // React escapes
})

export default i18n
